function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4298 23.288L79.4993 1.66406C78.6291 0.612375 77.3029 0 75.9077 0H23.0003C21.6051 0 20.279 0.612375 19.4087 1.66406L1.00854 23.8516C-0.0965747 25.1873 -0.312994 27.0111 0.455982 28.5509C1.22035 30.0818 2.83198 31.0625 4.60016 31.0625H9.20941V71H18.4187V31.0625H27.628V48.8125H36.8373V31.0625H62.1628V48.8125H71.3721V31.0625H80.5814V71H89.7907V31.0625H94.3079C94.3401 31.0625 94.3677 31.0625 94.4 31.0625C96.9417 31.0625 99 29.0789 99 26.625C99 25.2937 98.3922 24.1001 97.4298 23.288ZM80.5077 22.1875H71.3077H62.1076H36.8004H27.6004H18.4003H14.1732L25.2152 8.875H73.7021L84.744 22.1875H80.5077Z"
});

var SvgIcoTableBig = function SvgIcoTableBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 71,
    viewBox: "0 0 99 71",
    fill: "black",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoTableBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-table-big.0a1ce6f4.svg";
export { ForwardRef as ReactComponent };